export class ankerMenu{
    constructor() {
        $('.c-ankermenu a').on('click',function(e) {
            e.preventDefault();
            var target = this.hash;
            var $target = $(target);
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 900, 'swing', function () {
                window.location.hash = target;
            });
        });
        $( document ).ready(function() {
            var url = window.location.hash;
            if(url){
                var targetDiv = $(url);
                if(targetDiv && targetDiv.offset()){
                    $('html, body').stop().animate({
                        'scrollTop': targetDiv.offset().top
                    }, 900, 'swing');
                }
            }
        });
    }
}